import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as m } from "react";
const r = ({
  title: c,
  titleId: o,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...l,
    children: [
      c ? /* @__PURE__ */ e.jsx("title", { id: o, children: c }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M874.682 775.889c0-23.552-17.856-42.667-39.851-42.667H416.463c-22.016 0-39.851 19.115-39.851 42.667s17.835 42.667 39.851 42.667h418.368c21.995 0 39.851-19.115 39.851-42.667m0-164.48c0-23.552-17.856-42.667-39.851-42.667H416.463c-22.016 0-39.851 19.115-39.851 42.667 0 23.573 17.835 42.667 39.851 42.667h418.368c21.995 0 39.851-19.093 39.851-42.667m0-164.501c0-23.552-17.856-42.667-39.851-42.667H416.463c-22.016 0-39.851 19.115-39.851 42.667 0 23.573 17.835 42.667 39.851 42.667h418.368c21.995 0 39.851-19.093 39.851-42.667m0-164.48c0-23.552-17.856-42.667-39.851-42.667H416.463c-22.016 0-39.851 19.115-39.851 42.667 0 23.573 17.835 42.667 39.851 42.667h418.368c21.995 0 39.851-19.093 39.851-42.667m-533.355-5.099c0 47.125-38.208 85.333-85.333 85.333s-85.333-38.208-85.333-85.333 38.208-85.333 85.333-85.333 85.333 38.208 85.333 85.333",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = m(r);
export {
  n as default
};
